import React from 'react';
import helper from 'components/utils/helper';
import { Container } from 'themes/MoGrid';

const RichTextBlock = ({richTextBlock}) => {
    return (
        <Container>{richTextBlock && helper.renderParagraph(richTextBlock)}</Container>
    );
}
 
export default RichTextBlock;